import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout'
import MenuForm from '../../components/MenuForm';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';


export default function UserAdd() {
  return (
    <div style={{ margin: '2rem' }}>
      <AdminLayout />
      <Grid container style={{ marginTop: '4rem', marginBottom: '2rem' }}>
        <Grid item xs={12}>
          <Typography variant='h4' style={{ fontWeight: 'bold' }}>Create New Menu</Typography>
        </Grid>
        <Grid item xs={12} >
          <MenuForm mode='add' />
        </Grid>
      </Grid>
    </div>
  )
}